module.exports = __webpack_public_path__ + "static/trevor-9fbd642b197724eea357f77054cd8b98.png";